<template>
  <div class="postsDiv">
    <div v-if="!postsIsLoading" class="whiteDiv"></div>
    <div v-if="postsIsLoading" class="theLoader">
      <div class="loader"></div>
    </div>
    <div v-else v-html="posts" class="posts"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const fetchInitialData = (store, route, getConditions) => {
  return store.dispatch(`page/getPosts`, getConditions);
};
export default {
  data() {
    return {
      getConditions: {
        page: 1,
        archive: false,
        category: "all"
      }
    };
  },
  computed: {
    ...mapGetters("page", ["posts", "postsIsLoading"])
  },
  methods: {
    ...mapActions("page", {
      getPosts: "getPosts"
    }),
    loadData() {
      fetchInitialData(this.$store, this.$route, this.getConditions);
    }
  },
  watch: {},
  prefetch: fetchInitialData,
  mounted() {
    this.loadData();

    const element = document.getElementById("page");
    element.classList.add("addAnimation");
  },
  beforeCreate: function() {
    document.body.classList.remove("redBackground");
    document.body.classList.remove("invertedHeader");
  }
};
</script>

<style lang="scss">
.posts {
  display: flex;
  padding: 183px 0 0 336px;
  box-sizing: border-box;
  flex-wrap: wrap;
  > div {
    img {
      width: 100%;
      height: auto;
    }
    flex: 0 0 356px;
    width: 356px;
    max-width: 100%;
    margin: 10px 12px;

    @media (max-width: 576px) {
      margin: 0 auto;
    }
    h5 {
      margin-bottom: 0;
      margin-top: 0.8rem;
      font-size: 14px;
      text-transform: uppercase;
      a {
        color: #010e21;
        transition: all 0.3s;
        &:hover {
          color: #b61e3e;
          text-decoration: none;
          opacity: 0.8;
        }
      }
    }
    p {
      font-size: 12px;
    }
    div {
      position: relative;
      a {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0;
        cursor: pointer;
        transition: opacity 0.35s ease-in-out;
        background: rgba($color: #b61e3e, $alpha: 0.7);
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
.moved {
  .whiteDiv {
    display: block;
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    height: 45px;
    background: #fff;
    z-index: 1;
  }

  .whiteDiv {
    @media (max-width: 576px) {
	display: none;
      height: 100px;
    }
  }
}
</style>

